import React, { useState } from "react";
import PropTypes from "prop-types"; // Import PropTypes for type checkingames
import Popup from "reactjs-popup";
import { cn } from "../utils/utils";

const AlertButton = ({ children, className, onClick, refetch }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  // Handle confirm action
  const handleYes = (e) => {
    e.stopPropagation();
    onClick();
    setShowTooltip(false);
    if (typeof refetch === 'function') {
      refetch(); // Call refetch if provided
    }
  };

  // Handle cancel action
  // const handleNo = (e,close) => {
  //   close()
  //   e.stopPropagation();
  //   setShowTooltip(false);
  // };

  // Show tooltip on click
  const handleTooltip = (e) => {
    e.stopPropagation();
    setShowTooltip(true);
  };

  return (
    <Popup
    trigger={
      <button onClick={handleTooltip} className={cn("", className)}>
      {children}
    </button>
    }
    modal
    nested
  >
    {(close) => (
         <div
         dir="rtl"
         onMouseLeave={() => setShowTooltip(false)}
         className=" p-2 bg-neutral-00 shadow-xl rounded-lg border border-gray-300 z-50 transition-shadow duration-300 flex flex-col gap-2"
       >
         <p className="text-dark font-semibold">آیا مطمئن هستید؟</p>
         <div className="flex justify-center gap-2 p-2">
           <button onClick={()=>close()} className="btn-cancel">
             انصراف
           </button>
           <button onClick={handleYes} className="btn-container">
             تایید
           </button>
         </div>
       </div>
    )}
  </Popup>

    // <div className="relative flex items-center">
    //   <button onClick={handleTooltip} className={cn("", className)}>
    //     {children}
    //   </button>

    //   {showTooltip && (
    //     <div
    //       onMouseLeave={() => setShowTooltip(false)}
    //       className="z-90 absolute bottom-0 left-0 translate-x-[0%] translate-y-[120%] mt-2 w-fit p-2 bg-neutral-00 shadow-xl rounded-lg border border-gray-300 z-50 transition-shadow duration-300 flex flex-col gap-2"
    //     >
    //       <p className="text-dark font-semibold">آیا مطمئن هستید؟</p>
    //       <div className="flex justify-center gap-2 p-2">
    //         <button onClick={handleNo} className="btn-cancel">
    //           انصراف
    //         </button>
    //         <button onClick={handleYes} className="btn-container">
    //           تایید
    //         </button>
    //       </div>
    //     </div>
    //   )}
    // </div>
  );
};

// PropTypes to validate props
AlertButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  refetch: PropTypes.func, // Optional refetch function
};

export default AlertButton;
